import { render, staticRenderFns } from "./XianUnicom1.vue?vue&type=template&id=0591feae&scoped=true"
import script from "./XianUnicom1.vue?vue&type=script&lang=js"
export * from "./XianUnicom1.vue?vue&type=script&lang=js"
import style0 from "./XianUnicom1.vue?vue&type=style&index=0&id=0591feae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0591feae",
  null
  
)

export default component.exports